import styled from '@emotion/styled';

import { device, useRevealTrail } from '@landsbankinn/ui';
import React from 'react';

interface IProps {
  children: React.ReactNode;
  featured?: boolean;
  isSingleFeatured?: boolean;
}

const Group = styled.div<{ featured?: boolean; isSingleFeatured?: boolean }>`
  > * {
    margin-bottom: 2em;
  }

  > *:last-child {
    margin-bottom: 0;
  }

  @media ${device.tablet} {
    display: ${({ isSingleFeatured }) =>
      isSingleFeatured ? 'block' : '-ms-grid'};
    display: ${({ isSingleFeatured }) => (isSingleFeatured ? 'block' : 'grid')};
    grid-template-columns: ${({ featured, isSingleFeatured }) =>
      featured ? '2fr 1fr' : isSingleFeatured ? '1fr' : '1fr 1fr 1fr'};
    -ms-grid-columns: ${({ featured, isSingleFeatured }) =>
      featured
        ? '2fr 20px 1fr'
        : isSingleFeatured
        ? '1fr'
        : '1fr 20px 1fr 20px 1fr'};
    grid-template-rows: ${({ featured }) => (featured ? '1fr 1fr' : '1fr')};
    -ms-grid-rows: ${({ featured }) => (featured ? '1fr 0 1fr' : '1fr')};
    grid-template-areas: ${({ featured }) =>
      featured
        ? `"featured item2"
    "featured2 item3"`
        : 'item1 item2 item3'};
    grid-gap: 0 20px;

    > *:first-child {
      grid-area: ${({ featured, isSingleFeatured }) =>
        featured || isSingleFeatured ? 'featured' : 'item1'};
      -ms-grid-row: 1;
      -ms-grid-column: 1;
    }
    > *:nth-child(2) {
      grid-area: ${({ featured }) => (featured ? 'featured2' : 'item2')};
      -ms-grid-row: ${({ featured }) => (featured ? '3' : '1')};
      -ms-grid-column: ${({ featured }) => (featured ? '1' : '3')};
    }
    > *:nth-child(3) {
      -ms-grid-row: 1;
      -ms-grid-column: ${({ featured }) => (featured ? '3' : '5')};
      grid-area: ${({ featured }) => (featured ? 'item2' : 'auto')};
    }
    > *:nth-child(4) {
      -ms-grid-row: ${({ featured }) => (featured ? '3' : 'auto')};
      -ms-grid-column: ${({ featured }) => (featured ? '3' : 'auto')};
      grid-area: ${({ featured }) => (featured ? 'item3' : 'auto')};
    }

    > *:last-child {
      margin-bottom: 30px;
    }
  }
`;

export const OtherCardGroup = ({
  children,
  featured,
  isSingleFeatured,
}: IProps) => {
  const { ref, itemsWithStyleProp } = useRevealTrail(children);
  return (
    <Group featured={featured} isSingleFeatured={isSingleFeatured} ref={ref}>
      {itemsWithStyleProp}
    </Group>
  );
};
